import React, { useState, useEffect } from 'react';
import { urlApiProd } from '../utiles';

import AgregarCategoria from '../categorias/AgregarCategoria';
import AgregarEspecie from '../especies/AgregarEspecie';
import AgregarMedida from '../medidas/AgregarMedida';
import AgregarCalidad from '../calidades/AgregarCalidad';

const AgregarProducto = ({ cerrar, opciones, medidas }) => {
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const [showAgregarCategoria, setShowAgregarCategoria] = useState(false);
    const [categoriasLocales, setCategoriasLocales] = useState([]);
    const [showAgregarEspecie, setShowAgregarEspecie] = useState(false);
    const [especiesLocales, setEspeciesLocales] = useState([]);
    const [showAgregarMedida, setShowAgregarMedida] = useState(false);
    const [medidasLocales, setMedidasLocales] = useState([]);
    const [showAgregarCalidad, setShowAgregarCalidad] = useState(false);
    const [calidadesLocales, setCalidadesLocales] = useState([]);

    const [categoria, setCategoria] = useState('');
    const [especie, setEspecie] = useState('');
    const [ncm, setNcm] = useState('');
    const [medida, setMedida] = useState('');
    const [espesor, setEspesor] = useState('');
    const [nuevaCalidad, setNuevaCalidad] = useState('');

    const [espesoresDisponibles, setEspesoresDisponibles] = useState([]);

    useEffect(() => {
        if (opciones) {
            if (opciones.categorias) setCategoriasLocales(opciones.categorias);
            if (opciones.especies) setEspeciesLocales(opciones.especies);
            if (opciones.medidas) setMedidasLocales(opciones.medidas);
            if (opciones.calidades) setCalidadesLocales(opciones.calidades);
        }
    }, [opciones]);

    useEffect(() => {
        if (medida) {
            const mLocales = medidas || opciones.medidas || [];
            const medidaSeleccionada = mLocales.find(m => m.id_medida === parseInt(medida));
            if (medidaSeleccionada && medidaSeleccionada.espesor) {
                setEspesoresDisponibles(medidaSeleccionada.espesor);
            } else {
                setEspesoresDisponibles([]);
            }
            setEspesor('');
        }
    }, [medida, medidas, opciones.medidas]);

    useEffect(() => {
        if (categoria && especie) {
            const cat = categoriasLocales.find(c => c.id_categoria === parseInt(categoria));
            const esp = especiesLocales.find(e => e.id_especie === parseInt(especie));
            if (cat && esp && cat.ncm && esp.ncm) {
                setNcm(cat.ncm + '.' + esp.ncm)
            }
        }
    }, [categoria, especie, categoriasLocales, especiesLocales]);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!nuevaCalidad) {
            alert('Debe seleccionar una calidad.');
            return;
        }

        setBotonDeshabilitado(true);

        const nuevoProducto = {
            categoria: parseInt(categoria),
            especie: parseInt(especie),
            ncm,
            medida: parseInt(medida),
            espesor: parseFloat(espesor),
            id_calidad: parseInt(nuevaCalidad),
        };

        const token = localStorage.getItem('token');

        fetch(`${urlApiProd}/agregarproducto`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(nuevoProducto)
        })
            .then(response => {
                if (!response.ok) throw new Error('Error al agregar producto');
                return response.json();
            })
            .then(data => {
                alert('Producto agregado exitosamente');
                cerrar({
                    ...nuevoProducto,
                    id_producto: data.id_producto
                });
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Error al agregar producto');
            })
            .finally(() => {
                setBotonDeshabilitado(false);
            });
    };

    return (
        <div className='modal-overlay'>
            <div className='modal1'>
                <div className='card'>
                    <form onSubmit={handleSubmit}>
                        <div className='card-header'>
                            <h3 className='card-title' style={{ textAlign: 'center' }}>Agregar Producto</h3>
                        </div>
                        <div className='card-body'>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Categoría</span>
                                <select
                                    className="form-control"
                                    value={categoria}
                                    onChange={(e) => setCategoria(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Categoría</option>
                                    {categoriasLocales.map(cat => (
                                        <option key={cat.id_categoria} value={cat.id_categoria}>{cat.nombre}</option>
                                    ))}
                                </select>
                                <button type="button" className="btn btn-outline-primary" onClick={() => setShowAgregarCategoria(true)}>+</button>
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Especie</span>
                                <select
                                    className="form-control"
                                    value={especie}
                                    onChange={(e) => setEspecie(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Especie</option>
                                    {especiesLocales.map(esp => (
                                        <option key={esp.id_especie} value={esp.id_especie}>{esp.nombre}</option>
                                    ))}
                                </select>
                                <button type="button" className="btn btn-outline-primary" onClick={() => setShowAgregarEspecie(true)}>+</button>
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>NCM</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ncm}
                                    onChange={(e) => setNcm(e.target.value)}
                                    required
                                />
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Medida</span>
                                <select
                                    className="form-control"
                                    value={medida}
                                    onChange={(e) => setMedida(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Medida</option>
                                    {medidasLocales.map(m => (
                                        <option key={m.id_medida} value={m.id_medida}>{m.medida}</option>
                                    ))}
                                </select>
                                <button type="button" className="btn btn-outline-primary" onClick={() => setShowAgregarMedida(true)}>+</button>
                            </div>

                            {medida && (
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Espesor</span>
                                    <select
                                        className="form-control"
                                        value={espesor}
                                        onChange={(e) => setEspesor(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleccionar Espesor</option>
                                        {espesoresDisponibles.map((e, index) => (
                                            <option key={index} value={e}>{e}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Calidad</span>
                                <select
                                    className="form-control"
                                    value={nuevaCalidad}
                                    onChange={(e) => setNuevaCalidad(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Calidad</option>
                                    {calidadesLocales.map(c => (
                                        <option key={c.id_calidad} value={c.id_calidad}>{c.calidad}</option>
                                    ))}
                                </select>
                                <button type="button" className="btn btn-outline-primary" onClick={() => setShowAgregarCalidad(true)}>+</button>
                            </div>
                        </div>
                        <div className='card-footer' style={{ textAlign: 'center' }}>
                            <button type="submit" className="btn btn-outline-success mb-3 mt-3" disabled={botonDeshabilitado}>Agregar</button>
                            <button type="button" className="btn btn-outline-danger" onClick={cerrar}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>

            {showAgregarCategoria && <AgregarCategoria cerrar={(nueva) => { setShowAgregarCategoria(false); if (nueva) setCategoriasLocales(p => [...p, nueva]); }} />}
            {showAgregarEspecie && <AgregarEspecie cerrar={(nueva) => { setShowAgregarEspecie(false); if (nueva) setEspeciesLocales(p => [...p, nueva]); }} />}
            {showAgregarMedida && <AgregarMedida cerrar={(nueva) => { setShowAgregarMedida(false); if (nueva) setMedidasLocales(p => [...p, nueva]); }} />}
            {showAgregarCalidad && <AgregarCalidad cerrar={(nueva) => { setShowAgregarCalidad(false); if (nueva) setCalidadesLocales(p => [...p, nueva]); }} />}
        </div>
    );
};

export default AgregarProducto;
